<template>
  <div class="toggle-container">
    <button
      class="toggle-button"
      :class="{ 'toggle-button--active': modelValue }"
      @click="toggle"
      type="button"
      :aria-pressed="modelValue"
      :aria-label="label || 'Переключатель'"
    >
      <span class="toggle-switch">
        <span class="toggle-switch__handle" />
      </span>

      <span v-if="label" class="toggle-label" :class="{ 'toggle-label--active': modelValue }">
        {{ label }}
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: boolean;
  label?: string;
}>();

const emit = defineEmits<{
  (event: 'update:modelValue', value: boolean): void;
}>();

const toggle = () => {
  emit('update:modelValue', !props.modelValue);
};
</script>

<style scoped lang="scss">
.toggle-container {
  display: inline-block;
}

.toggle-button {
  display: flex;
  align-items: center;
  gap: 12px;

  cursor: pointer;
  transition: all 0.3s ease;
}

.toggle-switch {
  position: relative;

  width: 36px;
  height: 20px;

  background: $bg-color-medium;
  border-radius: 10px;

  transition: background 0.3s ease;

  .toggle-button--active & {
    background: $text-link-color;
  }
}

.toggle-switch__handle {
  position: absolute;
  top: 2px;
  left: 2px;

  width: 16px;
  height: 16px;

  background: $main-bg-color;
  border-radius: 50%;

  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  .toggle-button--active & {
    transform: translateX(16px);
  }
}

.toggle-label {
  font-size: $input-text-font-size;
  line-height: 20px;
  font-weight: 500;
  color: $text-secondary-color;

  transition: color 0.3s ease;

  &.toggle-label--active {
    color: $text-primary-color;
  }
}
</style>
